import QrManagementPage from 'pages/qr-management/QrManagementPage';
import { IRoute } from 'interfaces/Route';

export const QR_MANAGEMENT_ROUTES: IRoute[] = [
    {
        path: '/admin/qr-management',
        component: QrManagementPage,
        exact: true,
    },
];
